import Link from 'next/link';
import React from 'react';
import { AppBar as UiAppBar, IconButton, Logo } from 'ui';
import { Notes } from 'ui/icons';

import { AccountMenu } from './AccountMenu';

const ActionItems = () => <AccountMenu />;

interface Props {
  toggleSidebar?: () => void;
  showLogo?: boolean;
}

const AppBar = ({ showLogo = false, toggleSidebar }: Props) => {
  return (
    <UiAppBar>
      {showLogo && (
        <UiAppBar.Logo component={Link} href="/">
          <Logo size="big" />
        </UiAppBar.Logo>
      )}

      {toggleSidebar && (
        <IconButton onClick={toggleSidebar} data-testid="toggle-sidebar-button">
          <Notes sx={{ color: 'common.black' }} />
        </IconButton>
      )}

      <UiAppBar.Actions>
        <ActionItems />
      </UiAppBar.Actions>
    </UiAppBar>
  );
};

export default AppBar;
